import { render, staticRenderFns } from "./AccessLevelDynamicBadgeCompact.vue?vue&type=template&id=4b5d96d7&"
import script from "./AccessLevelDynamicBadgeCompact.vue?vue&type=script&lang=ts&"
export * from "./AccessLevelDynamicBadgeCompact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports